module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/shibuya_sns_02-196c0296989d063b0733eb902decab96.jpg";